<template>
    <div
        :style="styles"
        :class="`text-${color}`"
        class="load-spinner--stretch"
    >
        <div class="rect rect-1" />
        <div class="rect rect-2" />
        <div class="rect rect-3" />
        <div class="rect rect-4" />
        <div class="rect rect-5" />
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const DEFAULT_SIZE = '40px'

interface IStretch {
    size?: number
    color?: string
}

const props = withDefaults(
    defineProps<IStretch>(),
    {
        size: 40,
        color: 'primary'
    }
)

const styles = computed(() => {
    const size = props.size ? `${props.size}px` : DEFAULT_SIZE
    return {
        width: size,
        height: size
    }
})
</script>

<style lang="scss" scoped>
.load-spinner--stretch {
  @apply inline-flex gap-1 text-center;
  * {
    line-height: 0;
    box-sizing: border-box;
  }
}
.rect{
  animation: stretchAnimation 1.2s ease-in-out infinite;
  background-color: currentColor;
}
.load-spinner--stretch > div {
  height: 100%;
  width: 10%;
  display: inline-block;
}
.load-spinner--stretch .rect-2 {
  animation-delay: -1.1s;
}
.load-spinner--stretch .rect-3 {
  animation-delay: -1.0s;
}
.load-spinner--stretch .rect-4 {
  animation-delay: -0.9s;
}
.load-spinner--stretch .rect-5 {
  animation-delay: -0.8s;
}
@keyframes stretchAnimation {
  0%, 40%, 100% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1.0);
  }
}
</style>
